import React from 'react';
import { VStack, Text, Heading } from '@chakra-ui/react';

interface SectionHeaderProps {
  eyebrow: string;
  heading: string;
  description: string;
  centered?: boolean;
  maxW?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  eyebrow,
  heading,
  description,
  centered = true,
  maxW = '2xl',
}) => {
  return (
    <VStack
      gap="4"
      textAlign={centered ? 'center' : 'start'}
      maxW={maxW}
      mx={centered ? 'auto' : undefined}
    >
      <Text
        color="blue.fg"
        fontWeight="medium"
        letterSpacing="wide"
        fontSize="sm"
        textTransform="uppercase"
      >
        {eyebrow}
      </Text>
      <Heading fontSize={{ base: '3xl', md: '4xl' }} fontWeight="bold" letterSpacing="tight">
        {heading}
      </Heading>
      <Text fontSize={{ base: 'lg', md: 'xl' }} color="fg.muted" lineHeight="relaxed">
        {description}
      </Text>
    </VStack>
  );
};
